import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { DataGrid, GridValueFormatterParams } from "@material-ui/data-grid";
import { Fragment, useCallback, useEffect, useState } from "react";
import { Button, useDataProvider } from "react-admin";
import RegeneratePdfButton from "./RegeneratePdfButton";
import ShowPdfButton from "./ShowPdfButton";
import { StyledButton } from "../../../components/ListShowButton";

interface IShowDetailButton {
  detailId: number;
}

const ShowDetailButton = ({ detailId }: IShowDetailButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const [customerLedgers, setCustomerLedgers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
  });

  const classes = useStyles();
  const provider = useDataProvider();

  const getCustomerLedgers = (id: number) => {
    setLoading(true);
    provider.customGetOne(`customerLedgers/${id}`).then(({ data }: any) => {
      setCustomerLedgers(data.values);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (open) {
      getCustomerLedgers(detailId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const customerLedgerColumns = [
    {
      field: "documentNo",
      headerName: "Invoice Number",
      type: "string",
      flex: 1,
      filterable: false,
    },
    {
      field: "amountLcy",
      headerName: "Amt. Include VAT",
      type: "number",
      flex: 1,
      filterable: false,
      valueFormatter: (params: GridValueFormatterParams) =>
        `$ ${params.value.toLocaleString()}`,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      filterable: false,
      renderCell: (props: any) => {
        return (
          <div>
            <ShowPdfButton documentNo={props.row.documentNo} />
            <RegeneratePdfButton mbcRef={props.row.documentNo} />
          </div>
        );
      },
    },
  ];

  const onFilterChange = useCallback((filterModel: any) => {
    // setFilterValue(filterModel.items[0].value);
    console.log("TEST", filterModel);
  }, []);

  return (
    <Fragment>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Show Detail
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">Details Of Invoice</DialogTitle>
        <DialogContent>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={customerLedgers}
              columns={customerLedgerColumns}
              pageSize={100}
              rowsPerPageOptions={[100]}
              // filterMode="server"
              onFilterModelChange={onFilterChange}
              loading={loading}
              disableColumnMenu
            ></DataGrid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ShowDetailButton;
